import React, { Fragment } from 'react';
import moment from 'moment';

import { EiqDatePicker } from 'eiq-storybook';
import { DatePickerFieldDefaultProps, DatePickerFieldPropTypes } from 'src/components/DatePickerField/propTypes';
import 'react-datepicker/dist/react-datepicker.css';
import 'src/styles/DatePickerField.css';
import s from 'src/components/DatePickerField/DatePickerField.styles';

const DatePickerFieldComponent = ({
  action,
  auth,
  className,
  dateOnly,
  error,
  fieldClassName,
  flash,
  invisible,
  label,
  monthOnly,
  multiline,
  required,
  rounded,
  value,
  heightFitContent = false,
  popperPlacement = 'bottom-end',
  yearOnly,
  ...rest
}) => {
  let dateFormat = 'MMMM d, yyyy h:mm aa';
  if (dateOnly) {
    dateFormat = 'MMMM d, yyyy';
  }
  if (monthOnly) {
    dateFormat = 'MMMM, yyyy';
  }
  if(yearOnly){
    dateFormat = 'yyyy';
  }

  return (
    <s.DatePickerField
      auth={auth}
      className={className}
      flash={flash}
      invisible={invisible}
      monthOnly={monthOnly}
      yearOnly={yearOnly}
      onClick={e => e.preventDefault()}
      rounded={rounded}
      heightFitContent={heightFitContent}
      >
      {label && (
        <s.DatePickerFieldLabel auth={auth}>
          {label}
          {required && (
            <s.DatePickerFieldRequired auth={auth}>*</s.DatePickerFieldRequired>
          )}
        </s.DatePickerFieldLabel>
      )}
      {
        <s.DatePickerFieldWrapper className="eiq-date-picker-wrapper">
          <EiqDatePicker
            wrapperClassName="only-date-picker"
            selectedDate={value ? moment(value).toDate() : null}
            autoComplete="off"
            dateFormat={dateFormat}
            popperPlacement={popperPlacement}
            showMonthYearPicker={monthOnly}
            showYearPicker={yearOnly}
            showTimeSelect={!dateOnly}
            styles={{ width: '100%' }}
            timeCaption="time"
            timeFormat="HH:mm"
            timeIntervals={15}
            {...rest}
          />
          {error && (
            <s.DatePickerFieldError auth={auth}>{error}</s.DatePickerFieldError>
          )}
        </s.DatePickerFieldWrapper>
      }
      {action || ''}
    </s.DatePickerField>
  );
};

DatePickerFieldComponent.propTypes = DatePickerFieldPropTypes;
DatePickerFieldComponent.defaultProps = DatePickerFieldDefaultProps;

export const DatePickerField = React.memo(DatePickerFieldComponent);
